<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="sendDocHistories">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/2">
                  <h6>ข้อมูลการส่งเอกสาร</h6>
                </div>
                <div class="vx-col w-1/2 flex justify-end m-0 p-0">
                  <div class="flex">
                    <div class="mr-1 flex-1">
                      <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"  @click="onPressedActiveSendDocHistoryModal()" class="mb-1">เพิ่มข้อมูล</vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th>ครั้งที่</vs-th>
              <vs-th>วันที่ส่ง</vs-th>
              <vs-th>หมายเหตุ</vs-th>
              <vs-th class="col-createdBy">ผู้บันทึก</vs-th>
              <vs-th class="col-createdBy"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>{{ data.length - index }}</vs-td>
                <vs-td>{{ row.sendDateLocalTh }}</vs-td>
                <vs-td>{{ row.remark }}</vs-td>
                <vs-td>{{ row.createdByFullName }}<br>{{ row.createdAtDateTimeLocalTh }}</vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                    <vx-tooltip text="ลบข้อมูลการส่งเอกสาร">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="onPressedDelSendDocHistory(row.id)"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
    <vs-popup
      :active.sync="sendDocHistoryModal.active"
      title="เพิ่มข้อมูลการส่งเอกสาร"
      class="custom-popup"
    >
      <div class="popup-content">
        <vs-textarea  v-model="sendDocHistoryModal.remark" rows="5"/>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptAddSendDocHistory">บันทึก</vs-button>
        <vs-button color="danger" @click="sendDocHistoryModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import {createNamespacedHelpers, mapState} from "vuex";
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  name: 'SendDocHistoryTab',
  components: {Divider},
  data() {
    return {
      sendDocHistoryModal: {
        active: false,
        remark: "",
      },
    };
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapAccountingFields(['contractDetail', 'contractDetailSendDocHistories']),
    sendDocHistories() {
      if (!this.contractDetailSendDocHistories) return null;
      return [... this.contractDetailSendDocHistories]
        .sort(({createdAt: aCreatedAt}, {createdAt: bCreatedAt}) => new Date(bCreatedAt) - new Date(aCreatedAt))
        .map((sendDocHistory) => {
          const {
            id,
            seq,
            sendDate,
            remark,
            status,
            sendDateLocalTh,
            createdAtDateTimeLocalTh,
            createdByFullName,
          } = sendDocHistory;
          return {
            id,
            seq,
            sendDate,
            remark,
            status,
            sendDateLocalTh,
            createdAtDateTimeLocalTh,
            createdByFullName,
          }
        })
    },
    sendDocHistoriesReceivedStatus(){
      if(!this.contractDetail) return null;
      const { sendDocHistoriesReceivedStatus } = this.contractDetail;
      return sendDocHistoriesReceivedStatus
    },
  },
  methods: {
    ...mapAccountingActions([
      'createContractDetailSendDocHistory',
      'deleteContractDetailSendDocHistory',
    ]),
    async onPressedActiveSendDocHistoryModal() {
      this.sendDocHistoryModal.active = true
    },
    async onPressedAcceptAddSendDocHistory() {
      const vm = this
      const contractId  = this.$route.params.id;
      const {createContractDetailSendDocHistory} = vm;
      await createContractDetailSendDocHistory({
        contractId,
        form: {
          remark: vm.sendDocHistoryModal.remark,
        }
      })
      vm.sendDocHistoryModal.active = false;
      vm.sendDocHistoryModal.remark = "";
    },
    async onPressedDelSendDocHistory(id) {
      const vm = this
      const { deleteContractDetailSendDocHistory } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailSendDocHistory({
            id,
            vm
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}
.col-createdBy {
  width: 200px;
}
.col-actions {
  width: 150px;
}

.custom-popup .vs-popup {
  width: 600px;
}
.popup-content {
  padding: 10px;
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}
.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
